import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "inline", "autoTagWidth", "tagsPerRow"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var TagList = function TagList(props) {
  var children = props.children,
    inline = props.inline,
    autoTagWidth = props.autoTagWidth,
    tagsPerRow = props.tagsPerRow,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var wrappedChildren = /*#__PURE__*/React.createElement("div", {
    className: "tags-per-row-".concat(tagsPerRow)
  }, children);
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    className: classNames('taglist', !autoTagWidth && 'taglist-autowidth', !inline && 'taglist-vertical', tagsPerRow && 'row display-flex-sm flex-wrap-sm', props.className)
  }), tagsPerRow ? wrappedChildren : children);
};
TagList.defaultProps = {
  inline: true,
  autoTagWidth: false
};
TagList.propTypes = {
  inline: PropTypes.bool,
  autoTagWidth: PropTypes.bool,
  tagsPerRow: PropTypes.PropTypes.oneOf([1, 2, 3, 4, 6]),
  className: PropTypes.string
};
export default TagList;